module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_13",
      "title": "13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ACADEMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("“"), _c('span', {
    staticClass: "cic"
  }, [_vm._v("M")]), _vm._v("a’am, I am sorry!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“WHAAAT?! YOU ARE "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SORRY")]), _vm._v("?! IS THAT PART OF YOUR ALLOTTED VOCABULARY, BASIC?!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Buffering.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Ahh . . I don’t know")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("… is it?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No?… Ma’am?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“THEN WHAT "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ARE")]), _vm._v(" YOUR BASIC RESPONSES, BASIC?!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Shitballs.")]), _vm._v(" It was the first time I had ever been called "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("basic")]), _vm._v(". In any way. I still didn’t know the answer to her question. In fact, I had never not known so many things in my entire life.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The only thing I did know was that I had to give it my all. I knew that if I gave 200 percent all day, every day here at the academy, success would find me. This was the standard I’d set for myself before, and it only made sense that it would carry me through military training and beyond. It was about time I, once again, started to appreciate the power of leaving everything out on the floor. I wrapped up my train of thought, in time for Cadet She-Not-He to go one more round with our eardrums.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_14",
      "title": "14"
    }
  }, [_vm._v("“ALL OF YOU BASICS: LISTEN UP!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The audible chaos stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“FROM NOW ON, YOU ARE NOT ALLOWED TO ANSWER WITH ANYTHING OTHER THAN THESE SEVEN BASIC RESPONSES:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“YES, SIR.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“NO, SIR.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“SIR, I DO NOT KNOW.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“SIR, I DO NOT UNDERSTAND.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“SIR, MAY I ASK A QUESTION?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“SIR, MAY I MAKE A STATEMENT?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“AND FINALLY: NO EXCUSE, SIR.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“YOU MAY NOT USE ANY VARIANCE IN TONE OR INFLECTION WHEN RESPONDING. AND BE SURE YOU KNOW THE DIFFERENCE BETWEEN "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SIR")]), _vm._v(" … AND "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("MA’AM")]), _vm._v(". TRUST US WHEN WE SAY THESE ARE ALL OF THE RESPONSES THAT YOU WILL NEED FOR THE NEXT SIX WEEKS … IF YOU EVEN MAKE IT THAT LONG.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Her eyes burned a hole into me as she finished her speech, and like a perfectly timed tag team, her compatriot then jumped into the ring to verbally wrestle us to the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“FAAALLL INNN, BASICS!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I stopped midbreath like a game of freeze tag.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“ROOMMM, TENNNCH-HUTTT!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I felt a few classmates make sharp movements like mimes locking themselves into imaginary phone booths. Their muscles locked tightly, perfectly still. The rest of us looked like a bunch of deer in headlights.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“PATHETIC! ABSOLUTELY PATHETIC, BASICS! FROM THIS POINT FORWARD IN YOUR CADET CAREER STOP "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_15",
      "title": "15"
    }
  }, [_vm._v("EVERYTHING AND SHOOT TO ATTENTION WHEN YOU HEAR THIS COMMAND. NOOOWW, PEOPLE!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The gaggle of cadre bobbed in and around our novice group shouting commands like DJs at a bar mitzvah guiding us through an aggressive “Chicken Dance.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“STAND TALL!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“TUCK THOSE CHINS!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“ROLL THOSE SHOULDERS UP, BACK, AND DOWN, THEN HOLLLD!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Cluck, cluck, cluck, cluck")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“CLENCH YOUR HANDS INTO FISTS, WITH YOUR THUMBS ALONG THE SEAMS OF YOUR PANTS!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“HEELS TOGETHER, WHILE YOUR TOES FACE OUTWARD AT A FORTY-FIVE-DEGREE ANGLE!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I turned my head slightly to make sure I was doing everything quickly and correctly, and a very tall upperclassman appeared in my blind spot like an apparition, to correct my form. I swallowed my shriek.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well, well, wellll, Basic Cadet "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tate.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He made my name sound like an accusation.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“LOOK at that CHIN, just FLAPPIN’ IN THE BREEEZE … EYES ROAMIN’ ALL AROUND, WILLY-NILLY!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("We may have all downloaded this new USAFA “keyboard” into our brains’ settings apps, but I had no idea how to translate it yet. I grimaced, anticipating a Mad Hatter ending to what felt like his creepy Alice in Wonderland–style poem.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“TELL YOU WHAT I’M-ONNA DO, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("TAAATE")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yikes.")]), _vm._v(" His Southern drawl deconstructed my “Chicken Dance” into McNuggets with each drawn-out syllable.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_16",
      "title": "16"
    }
  }, [_vm._v("“I’M GONNA TAKE THOSE PRETTY LIL’ EEEYES OF YOURS, TATE, AN’ I’M ’ONNA LOCK ’EM UP IN CAAAGES AND THROW AWAY THE KEEEY! FROM NOW ON, WHEN YOU STAND AT ATTENTION, YOUR EYES ARE GONNA BE "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("CAGED.")]), _vm._v(" THAT MEANS LOCKED. STRAIGHT AHEAD AND UNMOVIN’!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The hairs on the back of my neck started standing at attention one by one.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“YES, SIR!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I choked out my response and followed Cadet McNugget’s orders, feeling instantly trapped. If they wanted us to learn quickly, I wondered why they would take away our observational ability. I needed to quickly figure out a way to peripherally compensate for my lifelong habit of learning by looking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A chill crept up my spine shooting every follicle on my body to join the ones on the back of my neck already at attention, as if the energy around us had screamed, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ROOOM tench-HUT!")]), _vm._v(" It felt like we were just … "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("wrong")]), _vm._v(". Everything we did, said, thought was just … "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I had always been extra sensitive to the vibe of any room, or that which each person emanates. Much of my love for people comes from the curiosity between immediately feeling their magnified emotions, and the challenge in figuring out why they felt that way. Being empathic can be positive when allowing me to read people and connect with them, but the refraction can be unnerving when the vibe is angry or aggressive.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As the cadre hovered over us, the energy swirling around us was total chaos. There was intrigue, fear, aggression, excitement, and anger. The "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Top Gun")]), _vm._v(" scenes wherein Maverick and Goose get in trouble started rolling through my head. It was a short reel, and spaced out in perfect Hollywood time, so that each disciplinary action was immediately followed by a chance for redemption and success. I could "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_17",
      "title": "17"
    }
  }, [_vm._v("handle any discomfort or feeling of doing something wrong, as long as I knew that there would be a chance to get it right. As long as I had the chance to prove myself. But that had yet to be confirmed. The trend in this weird new world seemed to be “elimination of all that was familiar.” So, along with any preconceived notions we might have had about how to sit, stand, walk, and talk, every bit of our self-confidence quickly began to crumble.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I took shallow breaths while we treaded there, in the choppy waters of the unknown, hoping that at least this initial agitation was temporary.…")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Basic training had begun in a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("big")]), _vm._v(" way.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0